import { FacilityGroupUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/facilityGroup_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

type FacilityGroupUpdatedDetailProps = {
  event: FacilityGroupUpdatedEvent;
};

export const FacilityGroupUpdatedDetail = ({
  event,
}: FacilityGroupUpdatedDetailProps) => {
  const previous = event.previousFacilityGroup;
  const current = event.updatedFacilityGroup;

  if (!previous || !current) {
    return (
      <Col className="@FacilityGroupUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'name',
      label: 'Name',
      previous: previous.name,
      current: current.name,
    },
  ];

  return (
    <Col className="@FacilityGroupUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Facility Group
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay label="Name" value={current.name} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
